var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Wizard", { staticClass: "md", attrs: { logo: false } }, [
    _c("div", { staticClass: "image-selector" }, [
      _c("a", {
        directives: [{ name: "close", rawName: "v-close" }],
        staticClass: "close",
        on: {
          click: function($event) {
            _vm.resolve()
          }
        }
      }),
      _vm._v(" "),
      _c(
        "form",
        { staticClass: "upload" },
        [
          _c("header", [
            _c("h3", [_vm._v(_vm._s(_vm._f("trans")("images:attach.choose")))])
          ]),
          _vm._v(" "),
          _c("FileUpload", {
            staticClass: "new-image",
            on: { uploaded: _vm.uploaded },
            model: {
              value: _vm.uploads,
              callback: function($$v) {
                _vm.uploads = $$v
              },
              expression: "uploads"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "list" },
        [
          _c("header", [
            _c("h3", [
              _vm._v(_vm._s(_vm._f("trans")("images:attach.title_pick")))
            ]),
            _vm._v(" "),
            _vm.sizeselect ? _c("br") : _vm._e(),
            _vm._v(" "),
            _vm.sizeselect && _vm.asynclist && _vm.asynclist.length
              ? _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.size,
                        expression: "size"
                      }
                    ],
                    staticClass: "size",
                    on: {
                      change: function($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function(o) {
                            return o.selected
                          })
                          .map(function(o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.size = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      }
                    }
                  },
                  _vm._l(_vm.sizes, function(label, sz) {
                    return _c("option", { domProps: { value: sz } }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm._f("trans")("images:sizes.title")) +
                          ": " +
                          _vm._s(label) +
                          "\n          "
                      )
                    ])
                  })
                )
              : _vm._e(),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.search,
                  expression: "search"
                }
              ],
              attrs: {
                placeholder: _vm._f("trans")("search_for"),
                type: "search"
              },
              domProps: { value: _vm.search },
              on: {
                keyup: function($event) {
                  if (
                    !("button" in $event) &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.seturl($event)
                },
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.search = $event.target.value
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "figure",
            {
              staticClass: "image-selectable no-image",
              on: {
                click: function($event) {
                  _vm.resolve(false)
                }
              }
            },
            [
              _c("ins"),
              _vm._v(" "),
              _c("figcaption", [
                _vm._v(_vm._s(_vm._f("trans")("images:attach.detach_title")))
              ])
            ]
          ),
          _vm._v(" "),
          _vm.asynclist
            ? [
                _vm._l(_vm.asynclist.list, function(image) {
                  return _c(
                    "figure",
                    {
                      staticClass: "image-selectable",
                      class: _vm.is_current(image.id)
                        ? "image-disabled"
                        : "image-available",
                      on: {
                        click: function($event) {
                          _vm.resolve(image)
                        }
                      }
                    },
                    [
                      _c("ItemImage", {
                        attrs: { item: image, size: _vm.size }
                      }),
                      _vm._v(" "),
                      _c("figcaption", { attrs: { title: image.name } }, [
                        _vm._v(_vm._s(image.name.substr(0, 9)))
                      ])
                    ],
                    1
                  )
                }),
                _vm._v(" "),
                _c("Pages", {
                  attrs: { pages: _vm.pages },
                  model: {
                    value: _vm.p,
                    callback: function($$v) {
                      _vm.p = $$v
                    },
                    expression: "p"
                  }
                })
              ]
            : _c("Loading")
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-08e14be0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08e14be0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/helpers/components/interact/ImageBrowser.vue
// module id = null
// module chunks = 